import { Flex, Text } from '@chakra-ui/react';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion } from '@morressier/alembic';
import MultilineText from 'src/components/MultilineText';
import { formatDate } from 'src/utils/date';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { EditorialAttachments } from './EditorialAttachments';

export const UnsubmitFeedbackAccordion = () => {
  const {
    workflowResponse: {
      workflowData: {
        currentState,
        dateEnteredCurrentPhase: dateEntered
      }
    },
    unsubmit: data,
    submissionContextId
  } = useSubmissionData();

  if (currentState !== 'unsubmitted' || !data) return null;

  const { attachments, editorComment } = data || {};

  return (
    <Accordion
      chakraAccordionProps={{
        allowMultiple: true,
        defaultIndex: [0],
        width: '100%',
        background: 'surfacePrimaryFill',
        marginBottom: '20px'
      }}
      accordionItemProps={{ marginBottom: 0 }}
      items={[
        {
          title: (
            <Flex
              alignItems="center"
              columnGap={2}
              rowGap={1}
              flexWrap="wrap"
            >
              <Text
                textStyle="headingGroup"
                id="Submission Unsubmitted by Editors"
              >
                Submission Unsubmitted by Editors
              </Text>
              <Flex alignItems="center" gap={2} textStyle="textContext">
                <FontAwesomeIcon icon={faCalendar} />
                <Text>Received {formatDate(new Date(dateEntered))}</Text>
              </Flex>
            </Flex>
          ),
          content: (
            <Flex flexDirection="column" gap={3}>
              {editorComment && (
                <Flex gap={1} flexDirection="column">
                  <Text textStyle="headingLine">Editor&apos;s response</Text>
                  <MultilineText textStyle="textBody" text={editorComment} />
                </Flex>
              )}
              <EditorialAttachments
                attachments={attachments}
                submissionContextId={submissionContextId}
              />
            </Flex>
          )
        }
      ]}
    />
  );
};
